/* @flow */

import React from 'react';
import Styled from 'styled';
import { observer } from 'mobx-react';

import CommentView, { CommentViewModel } from 'four-nets/common/comment/comment-view';

export class MessageViewModel extends CommentViewModel {
    message: Message;

    constructor(options) {
        const { message, ...rest } = options;

        super({
            comment: message,
            ...rest,
        });

        this.message = message;
    }
}

@observer
class MessageView extends React.Component {
    render() {
        const { messageViewModel, ...rest } = this.props;

        return <CommentView commentViewModel={messageViewModel} {...rest} />;
    }
}

export default MessageView;
